import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { CalculatedDueValue, validateTaxYear } from "../../../../helpers/utils/Utils";
import InputField from "../../../../components/common/form/InputField";

interface RowData {
    baseTaxDue: string | null;
    taxYear: string | null;
    hasSuit: boolean;
    expectedDue: string | null;
    calculatedDue: number | null;
}

interface ErrorObject {
    errorMsg: string;
    index: number;
}

interface CalculatorGridProps {
    taxRoundingConfiguration: any;
}



const CalculatorGrid: React.FC<CalculatorGridProps> = ({ taxRoundingConfiguration }) => {
    const [attorneyFeePercentage, setAttorneyFeePercentage] = useState<any>(0.2);
    const [earlyAttorneyFeePercentage, setEarlyAttorneyFeePercentage] = useState<any | null>(null);
    const [asOfDate, setAsOfDate] = useState<string>(new Date().toISOString().substr(0, 10));
    const [list, setList] = useState<RowData[]>([]);
    const [render, setRender] = useState<boolean>(false);
    const [isEdited, setIsEdited] = useState<boolean>(false);
    const [errorObj, setErrorObj] = useState<ErrorObject[]>([]);




    useEffect(() => {
        if (list.length === 0) return;
        list.forEach((el, index) => {
            const totalTaxCalculatorObj = {
                ...list[index],
                attorneyFee: attorneyFeePercentage,
                earlyAttorneyFee: earlyAttorneyFeePercentage,
                asOfDate: asOfDate,
                taxRoundingConfiguration: taxRoundingConfiguration
            };
            CalculatedDueValue(totalTaxCalculatorObj, setRender, list, index).then();
        });
    }, [taxRoundingConfiguration, isEdited]);

    return (
        <div className="flex justify-center mt-3 text-sm">
            <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                <div className="col-span-12 grid grid-cols-12 gap-3">
                    <div className="relative col-span-12 flex items-center gap-3">
                        <div className="w-full">
                            <InputField type="date" placeholder="Enter As of Date..." value={asOfDate}
                                hideLabel
                                onChange={(e) => {
                                    setAsOfDate(e.target.value);
                                    setIsEdited(!isEdited);
                                }}
                            />
                        </div>
                        <div className="w-full">
                            <InputField  type="number"
                                name="attorneyFeePercentage"
                                hideLabel
                                onChange={(e) => {
                                    setAttorneyFeePercentage(parseFloat(e.target.value));
                                    setIsEdited(!isEdited);
                                }}
                                value={attorneyFeePercentage}
                                placeholder="Enter Attorney Fee Pct..."
                            />
                        </div>
                        <div className="w-full">
                            <InputField  type="number"
                                name="earlyAttorneyFeePercentage"
                                hideLabel
                                onChange={(e) => {
                                    setEarlyAttorneyFeePercentage(parseFloat(e.target.value));
                                    setIsEdited(!isEdited);
                                }}
                                value={earlyAttorneyFeePercentage}
                                placeholder="Enter Early Attorney Fee Pct..."
                            />
                        </div>
                        <div className="col-sm-1 mt-1 text-center">
                            <i className="fa fa-plus-circle" title="Add Row" onClick={(e) => {
                                e.preventDefault();
                                setList([...list, {
                                    baseTaxDue: null,
                                    taxYear: null,
                                    hasSuit: false,
                                    expectedDue: null,
                                    calculatedDue: null
                                }]);
                                setRender(!render);
                            }}></i>
                        </div>
                    </div>
                </div>

                <table className="w-full mt-5">
                    <thead className="bg-highlight-5 text-text-0">
                        <tr>
                            <th className="text-center">Base Tax Due</th>
                            <th className="text-center">Tax Year</th>
                            <th>Has Suit</th>
                            <th className="text-center">Expected Due</th>
                            <th className="text-center">Calculated Due</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody className="table-striped text-sm bg-text-1">
                        {list.length === 0 && (
                            <tr>
                                <td colSpan={6}>There are no rows to display</td>
                            </tr>
                        )}
                        {list.length > 0 && list.map((row, index) => {
                            const errorAtIndex = errorObj.find(obj => obj.index === index);
                            return (
                                <tr key={index}>
                                    <td>
                                        <NumberFormat
                                            placeholder={'...'}
                                            className="form-control text-center border border-surface-5"
                                            decimalSeparator="."
                                            fixedDecimalScale
                                            prefix={row?.baseTaxDue ? "$" : ''}
                                            value={row?.baseTaxDue ? parseFloat(row?.baseTaxDue).toFixed(2) : ''}
                                            thousandSeparator={true}
                                            onChange={(e: any) => {
                                                const newList = [...list];
                                                newList[index].baseTaxDue = e.target.value.replace('$', '').replaceAll(',', '');
                                                setList(newList);
                                                setIsEdited(!isEdited);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            className={errorAtIndex ? "text-center error_style border border-surface-5" : "text-center border border-surface-5"}
                                            type="number"
                                            placeholder="..."
                                            value={row?.taxYear ?? ''}
                                            onChange={(e) => {
                                                const newList = [...list];
                                                let val = e.target.value;
                                                newList[index].taxYear = val.length > 4 ? val.slice(0, 4) : val;
                                                setList(newList);

                                                const errorMsg = validateTaxYear(val, [], false);
                                                if (errorMsg) {
                                                    if (!errorObj.some(el => el.index === index)) {
                                                        setErrorObj([...errorObj, { errorMsg, index }]);
                                                    }
                                                } else {
                                                    setErrorObj(errorObj.filter(el => el.index !== index));
                                                }
                                                setIsEdited(!isEdited);
                                            }}
                                        />
                                        {errorAtIndex && <p className="mb-0">{errorAtIndex.errorMsg}</p>}
                                    </td>
                                    <td>
                                        <input
                                            className="ml-4 mt-3 border border-surface-5"
                                            type="checkbox"
                                            name="hasSuit"
                                            checked={row?.hasSuit}
                                            onChange={(e) => {
                                                const newList = [...list];
                                                newList[index].hasSuit = e.target.checked;
                                                setList(newList);
                                                setIsEdited(!isEdited);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <NumberFormat
                                            placeholder={'...'}
                                            className="form-control text-center border border-surface-5"
                                            decimalSeparator="."
                                            fixedDecimalScale
                                            prefix={row?.expectedDue ? "$" : ''}
                                            value={row?.expectedDue ? parseFloat(row?.expectedDue).toFixed(2) : ''}
                                            thousandSeparator={true}
                                            onChange={(e: any) => {
                                                const newList = [...list];
                                                newList[index].expectedDue = e.target.value.replace('$', '').replaceAll(',', '');
                                                setList(newList);
                                                setIsEdited(!isEdited);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <NumberFormat
                                            placeholder={'...'}
                                            className={
                                                row?.calculatedDue !== Number(row?.expectedDue ?? '')
                                                    ? "form-control text-center error border border-surface-5"
                                                    : "form-control text-center border border-surface-5"
                                            }
                                            decimalSeparator="."
                                            fixedDecimalScale
                                            prefix={row["calculatedDue"] && row["calculatedDue"] != null && row["calculatedDue"] ? "$" : ''} value={
                                                row?.calculatedDue !== null && row?.calculatedDue !== undefined
                                                    ? row?.calculatedDue?.toFixed(2)
                                                    : ''
                                            }
                                            thousandSeparator={true}
                                            readOnly={true}
                                        />

                                    </td>
                                    <td className="text-center">
                                        <i className="fa fa-trash" title="Delete Row" onClick={(e) => {
                                            e.preventDefault();
                                            const newList = list.filter((_, i) => i !== index);
                                            setList(newList);
                                            setRender(!render);
                                        }}></i>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CalculatorGrid;